import { createContext, useContext } from 'react'; // eslint-disable-next-line @typescript-eslint/naming-convention

export var _TableContext = /*#__PURE__*/createContext({});
export var _useTableContext = () => useContext(_TableContext);
//# sourceMappingURL=_TableContext.js.map